import React from 'react';

const UsuarioContext = React.createContext();
export default UsuarioContext;
